import { render } from "./PoliceStation.vue?vue&type=template&id=29fba3ba&scoped=true"
import script from "./PoliceStation.vue?vue&type=script&lang=js"
export * from "./PoliceStation.vue?vue&type=script&lang=js"

import "./PoliceStation.vue?vue&type=style&index=0&id=29fba3ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fba3ba"]])

export default __exports__